import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RestartDeclarationSheetComponent } from '@sc/ui-components';
import { RestartDeclarationOutputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-restart-declaration-dialog',
  styleUrls: ['./restart-declaration-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RestartDeclarationSheetComponent],
  template: `
    <sc-restart-declaration-sheet
      (confirmEvent)="onConfirm($event)"
      (cancelEvent)="onCancel($event)"
    ></sc-restart-declaration-sheet>
  `,
})
export class RestartDeclarationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RestartDeclarationOutputData,
    private readonly dialogRef: MatDialogRef<
      RestartDeclarationDialogComponent,
      RestartDeclarationOutputData
    >
  ) {}

  onConfirm(result) {
    this.dialogRef.close({ type: 'success' });
  }

  onCancel(result) {
    this.dialogRef.close({ type: 'cancel' });
  }
}
